import React from "react";
import { investmentIcon, Globe, Rent, Fees } from "./../../Public/assets/index";
import { QuickActionCard } from "./../../Components/CurrencyCard";

const QuickActions = ({ setIsOpen, arrow = true, partnerHealthDisable }) => (
  <div className="  mt-6 lg:mt-0 mx-6  lg:mx-0">
    <h2 className="text-xl font-geomanistBold mb-6">Quick Actions</h2>
    <div className="grid  grid-cols-1 sm:grid-cols-2 gap-[23px] 2xl:gap-11  xl:grid-cols-4">
      <QuickActionCard
        icon={
          <img
            src={investmentIcon}
            alt=""
            className="text-blueish "
            size={24}
          />
        }
        title1="Save
        and
        invest
        money"
        title2="for
        future
        expenses"
        // isUpcoming
        bgColor="bg-[#E1FBF7]"
        // arrow={arrow || partnerHealthDisable}
        // onClick={() => {
        //   arrow && !partnerHealthDisable && setIsOpen(true);
        // }}
      />
      <QuickActionCard
        icon={<img src={Globe} alt="" className="text-blueish" size={24} />}
        title1="Send to your own "
        title2="overseas bank account"
        bgColor="bg-[#D0EBFF]"
      />
       <QuickActionCard
        icon={<img src={Fees} alt="" className="text-blueish" size={24} />}
        title1="Send money for"
        title2="tuition fees"
        
        bgColor="bg-[#FFE2C7]"
      />
      <QuickActionCard
        icon={<img src={Rent} alt="" className="text-blueish" size={24} />}
        title1="Send money for rent "
        title2="& expenses"
        isUpcoming
        bgColor="bg-[#FFE9FD]"
      />
     
    </div>
  </div>
);

export default QuickActions;
